import React, { Suspense } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from 'react-router-dom';
import { ToastProvider, ArchReAppContextProvider } from '@archre2/react-core';
import ErrorBoundary from './errorPage';
import MainRouter from './router';
import LoadingPage from './loadingPage';
import MainNavigation from './navigation';
import { tracker } from '@archre2/react-core';
import { setAuthContext } from '../auth';
import configuration from '../config';
import { client, uploadClient } from 'core/api/graphql';
import {
  rootRoute,
  DOCUMENT_OWNER_TYPE,
  WORKFLOW_OWNER_TYPE,
} from 'constants/constants';
import PageContent from 'components/PageContent';
import PageFooter from './PageFooter';
// import PageFooter from 'components/PageFooter';

const config = {
  WORKFLOW_CONFIG: {
    DOCUMENT_OWNER_TYPE: DOCUMENT_OWNER_TYPE,
    WORKFLOW_OWNER_TYPE: WORKFLOW_OWNER_TYPE,
    ROOT_PATH: '/workflow',
    GRAPHQL_CLIENT: client,
    GRAPHQL_UPLOAD_CLIENT: uploadClient,
    APP_BASE_URL: rootRoute === '/' ? '' : rootRoute,
    FINISH_TASK_STEP_CONFIG: {
      DISABLE_FINISH_TASK_ON_TASK_STATUS_CLICK: true,
      DISABLE_FINISH_TASK_ACTION: true,
    },
    DOCUMENT_CONFIG: {
      readOnlyDefault: ['.pdf'],
      previewDisabled: ['.xlsx', '.xls', '.xlsm', '.xlsb', '.xltx', '.csv'],
      hideSidepanelPdfByDefault: true,
    },
    ...configuration,
  },
  COMMENTS_CONFIG: {
    DOCUMENT_OWNER_TYPE: DOCUMENT_OWNER_TYPE,
    WORKFLOW_OWNER_TYPE: WORKFLOW_OWNER_TYPE,
    GRAPHQL_CLIENT: client,
    GRAPHQL_UPLOAD_CLIENT: uploadClient,
    APP_BASE_URL: rootRoute,
    NOTES_CONFIG: {
      ALLOW_EDIT: true,
    },
    ...configuration,
  },
  CLIENTINFO_CONFIG: {},
  USER_CONFIG: {
    SYSTEM_CODE: WORKFLOW_OWNER_TYPE,
    GRAPHQL_CLIENT: client,
    GRAPHQL_UPLOAD_CLIENT: uploadClient,
    APP_BASE_URL: rootRoute,
    ...configuration,
  },
  APP_SETTINGS: {
    ...configuration,
  },
};
const MainApp = () => {
  const navigate = useNavigate();
  return (
    <ErrorBoundary tracker={tracker}>
      <ArchReAppContextProvider
        configurations={config}
        setAuthContextValues={(cb) => setAuthContext(cb, navigate)}
      >
        <Suspense fallback={<LoadingPage />}>
          <ToastProvider
            className="margin-xl"
            toastStyle="radius-xxs shadow-xs"
          >
            <div className="container">
              <MainNavigation />
              <PageContent config={configuration}>
                <MainRouter />
              </PageContent>
              <PageFooter config={configuration} footer={true} />
            </div>
          </ToastProvider>
        </Suspense>
      </ArchReAppContextProvider>
    </ErrorBoundary>
  );
};

const App = () => {
  return (
    <React.StrictMode>
      <Router>
        <Routes>
          <Route path="/*" element={<MainApp />} />
        </Routes>
      </Router>
    </React.StrictMode>
  );
};
export default App;
